import { ProfileInfo } from "@circle-react/components/ProfileModalV3/Body/About/Info";
import { useProfileContext } from "@circle-react/components/ProfileModalV3/context";

export const ProfileAbout = () => {
  const { member } = useProfileContext();

  return <ProfileInfo member={member} />;
};
